import { ProductExchangeOrSectionInfoSchema } from "@redotech/redo-agents-common/returns-agents/exchange-agent/product-exchange-recommendation";
import { ReturnProductSchema } from "@redotech/redo-return-core-common/draft-return/draft-return-items";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getPersonalizedRecommendationsStream = unaryStreamRpc({
  name: "getPersonalizedRecommendationsStream" as const,
  input: z.object({
    draftReturnId: z.string(),
    currentReturnProductId: z.string(),
    selectedProductsForReturn: z.array(ReturnProductSchema),
    waitForProductPreferences: z.boolean(),
    locale: z.string().optional(),
  }),
  output: ProductExchangeOrSectionInfoSchema,
});
